// components
import type { AnalysisType } from '@/features/energyxplorer/types';
import useSearchParams from '@/hooks/useStableSearchParams';

const DEGREE_DAY_CORRECTION_PARAM = 'degreeDayCorrection';

const usePortfolioDegreeDayCorrection = (analysisType?: AnalysisType) => {
  const [searchParams, setSearchParams] = useSearchParams();

  const isDegreeDayCorrectionEnabled =
    analysisType === 'heat' &&
    searchParams.get(DEGREE_DAY_CORRECTION_PARAM) === 'true';

  const setDegreeDayCorrection = (enabled: boolean) => {
    setSearchParams((prev: URLSearchParams) => {
      const next = new URLSearchParams(prev);

      if (enabled) {
        next.set(DEGREE_DAY_CORRECTION_PARAM, 'true');
      } else {
        next.delete(DEGREE_DAY_CORRECTION_PARAM);
      }

      return next;
    });
  };

  return {
    isDegreeDayCorrectionEnabled,
    setDegreeDayCorrection,
  };
};

export default usePortfolioDegreeDayCorrection;
